"use client";
import React, { useState, useEffect } from "react";

function sticky() {
  const [currentUrl, setCurrentUrl] = useState("");

  useEffect(() => {
    // Yeh code client-side render hone par chalega
    setCurrentUrl(window.location.href);
  }, []);

  if (!currentUrl) {
    return null; // Agar currentUrl abhi set nahi hua hai, toh kuch render na karein
  }

  return (
    <>
      <div
        className="display"
        style={{
          margin: "0",
          height: "3400px",
          position: "absolute",
        }}
      >
        <div
          class="icon-bar 
        "
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                currentUrl
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="facebook"
            >
              <svg
                width="25"
                height="42"
                viewBox="0 0 40 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M40 20.6998C40 9.26728 31.046 0 20 0C8.954 0 0 9.26728 0 20.6998C0 31.031 7.314 39.5945 16.876 41.147V26.6841H11.796V20.6998H16.876V16.1396C16.876 10.9522 19.86 8.0874 24.43 8.0874C26.618 8.0874 28.906 8.49104 28.906 8.49104V13.5832H26.386C23.9 13.5832 23.126 15.1791 23.126 16.8165V20.6998H28.672L27.786 26.682H23.126V41.147C32.686 39.5945 40 31.031 40 20.6998Z"
                  fill="#2B3252"
                />
              </svg>
            </a>

            <a
              href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                currentUrl
              )}&text=Check%20this%20out!`}
              target="_blank"
              rel="noopener noreferrer"
              className="twitter"
            >
              <svg
                width="20"
                height="40"
                viewBox="0 0 40 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.8054 16.947L38.6963 0.00976562H35.1677L22.2379 14.7162L11.9109 0.00976562H0L15.6164 22.2484L0 40.0098H3.52887L17.183 24.4793L28.0891 40.0098H40L23.8046 16.947H23.8054ZM18.9722 22.4444L4.80037 2.60911H10.2205L35.1693 37.5286H29.7492L18.9722 22.4452V22.4444Z"
                  fill="#2B3252"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default sticky;
